// SidebarToggle.jsx
import React from 'react';
import { FiSidebar } from 'react-icons/fi';
import { useDispatch, useSelector } from 'react-redux';
import { toggleSidebar } from '../slices/uiSlice';
import useFlagsHook from '../hooks/useFlags.hook';
import PropTypes from 'prop-types';
import { Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';

const SidebarToggle = ({ isSidebarHovered, setIsSidebarHovered }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const sidebarExpanded = useSelector((state) => state.ui.sidebarExpanded);
  const { getFlagValue, loading } = useFlagsHook();

  if (loading) return null;

  return getFlagValue('SIDEBAR_TOGGLE') === '1' ? (
    <Tooltip title={t('toggleSidebar')} placement='top'>
      <div
        onClick={(e) => {
          e.preventDefault(); // 🚫 prevent navigation
          e.stopPropagation(); // 🚫 stop bubbling
          dispatch(toggleSidebar()); // or toggleSidebar()
          // setIsSidebarHovered((prev) => !prev); // Toggle hover state
        }}
        className='sidebar-toggle-btn'
        aria-label='Toggle Sidebar'
      >
        {isSidebarHovered ? (
          // 👈 Collapse icon (chevrons-left)
          <svg
            xmlns='http://www.w3.org/2000/svg'
            width='18'
            height='18'
            viewBox='0 0 24 24'
            fill='none'
            stroke='currentColor'
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
          >
            <path d='M11 7l-5 5l5 5' />
            <path d='M17 7l-5 5l5 5' />
          </svg>
        ) : (
          // 👉 Expand icon (chevrons-right)
          <svg
            xmlns='http://www.w3.org/2000/svg'
            width='18'
            height='18'
            viewBox='0 0 24 24'
            fill='none'
            stroke='currentColor'
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
          >
            <path d='M7 7l5 5l-5 5' />
            <path d='M13 7l5 5l-5 5' />
          </svg>
        )}
      </div>
    </Tooltip>
  ) : (
    <div className='sidebar-toggle'>
      <label className='circle-checkbox cursor-pointer'>
        <FiSidebar size={20} />
        <input
          type='checkbox'
          checked={sidebarExpanded}
          onChange={() => dispatch(toggleSidebar())}
        />
      </label>
    </div>
  );
};

SidebarToggle.propTypes = {
  isSidebarHovered: PropTypes.bool,
  setIsSidebarHovered: PropTypes.func,
};

export default SidebarToggle;
